import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from 'gatsby';
import Randomizer from '../components/randomizer';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "salt-lake-acting-company",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#salt-lake-acting-company",
        "aria-label": "salt lake acting company permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Salt Lake Acting Company`}</h1>
    <blockquote>
      <p parentName="blockquote">{`🔇 We appreciate you silencing your phone.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`Please tap an image below to view the digital publication.`}</p>
    </blockquote>
    {
      /* CURRENT PUBLICATIONS --------------------------------------------------*/
    }
    <h2 {...{
      "id": "tonights-show",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#tonights-show",
        "aria-label": "tonights show permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Tonight’s Show`}</h2>
    <section className="home-list">
      <Link to="/slacabaret-2022" alt="Link to SLACabaret publication." mdxType="Link">
        <p><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "730px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "155.83333333333334%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIDBAX/xAAWAQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAeUzVmsZQuSmehMUP//EAB0QAAIBBAMAAAAAAAAAAAAAAAECAAMQEiERIjL/2gAIAQEAAQUCC6xhinXYyoMX8gVOAdmM1v/EABURAQEAAAAAAAAAAAAAAAAAABEg/9oACAEDAQE/ASP/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAeEAACAQMFAAAAAAAAAAAAAAABEQAQITECEjJxof/aAAgBAQAGPwJ7Zx9pmFaj0oQ8Rg3Mya2dP//EAB4QAQACAgEFAAAAAAAAAAAAAAEAESExEEFRYYGh/9oACAEBAAE/IUzJ9wuXaBTCBVYgBNkGyqD4gekbRMdj3gppgIX87eP/2gAMAwEAAgADAAAAELQATP/EABcRAQEBAQAAAAAAAAAAAAAAAAEREDH/2gAIAQMBAT8QiUwU5n//xAAWEQEBAQAAAAAAAAAAAAAAAAABESD/2gAIAQIBAT8Qosx//8QAHxABAQADAAICAwAAAAAAAAAAAREAITFBUYGhEGFx/9oACAEBAAE/EIAN2JFOczg062JvzrWaK+L/AD9Y6rGkXnx2cyvGKKE9ff3inqpQni4xlSneI2JLcCcTcPOKu1VuO7C9nnBq/wBJPg/H/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/53ccff43af5d3f0d0031e8b546d6009c/8ac56/cabaret-cover-2022.webp 240w", "/static/53ccff43af5d3f0d0031e8b546d6009c/d3be9/cabaret-cover-2022.webp 480w", "/static/53ccff43af5d3f0d0031e8b546d6009c/87ca7/cabaret-cover-2022.webp 730w"],
                "sizes": "(max-width: 730px) 100vw, 730px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/53ccff43af5d3f0d0031e8b546d6009c/09b79/cabaret-cover-2022.jpg 240w", "/static/53ccff43af5d3f0d0031e8b546d6009c/7cc5e/cabaret-cover-2022.jpg 480w", "/static/53ccff43af5d3f0d0031e8b546d6009c/1a144/cabaret-cover-2022.jpg 730w"],
                "sizes": "(max-width: 730px) 100vw, 730px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/53ccff43af5d3f0d0031e8b546d6009c/1a144/cabaret-cover-2022.jpg",
                "alt": "SLACABARET Cover",
                "title": "SLACABARET Cover",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span></p>
  <div className="homeButtons">SLACabaret 2022</div>
      </Link>
      <a href="https://saltlakeactingcompany.org" target="_blank" rel="">
        <p><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "730px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "155.83333333333334%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAECAwT/xAAXAQEBAQEAAAAAAAAAAAAAAAAAAgEE/9oADAMBAAIQAxAAAAHpLquPIYp1mNYg/8QAGhABAQACAwAAAAAAAAAAAAAAAQAREhAgMf/aAAgBAQABBQLkBtGTEOLe96f/xAAYEQACAwAAAAAAAAAAAAAAAAAAAhARIf/aAAgBAwEBPwFUwqf/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAVEAEBAAAAAAAAAAAAAAAAAAAgIf/aAAgBAQAGPwI1/wD/xAAcEAEAAgEFAAAAAAAAAAAAAAABADERECAhUWH/2gAIAQEAAT8h1QDLl8l1RniOkRSUEVtzs//aAAwDAQACAAMAAAAQCNxB/8QAGBEAAwEBAAAAAAAAAAAAAAAAAAERIXH/2gAIAQMBAT8QZ0ZFZBJn/8QAFxEBAAMAAAAAAAAAAAAAAAAAAQAQEf/aAAgBAgEBPxBZt//EABwQAQEAAgIDAAAAAAAAAAAAAAERACFBURAgMf/aAAgBAQABPxDzxQzHesflyPCy6c4rNopsxsbnItxwWoIXr0//2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ddf83ae71f9e532c86f178fb160cbd29/8ac56/placeholder.webp 240w", "/static/ddf83ae71f9e532c86f178fb160cbd29/d3be9/placeholder.webp 480w", "/static/ddf83ae71f9e532c86f178fb160cbd29/87ca7/placeholder.webp 730w"],
                "sizes": "(max-width: 730px) 100vw, 730px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ddf83ae71f9e532c86f178fb160cbd29/09b79/placeholder.jpg 240w", "/static/ddf83ae71f9e532c86f178fb160cbd29/7cc5e/placeholder.jpg 480w", "/static/ddf83ae71f9e532c86f178fb160cbd29/1a144/placeholder.jpg 730w"],
                "sizes": "(max-width: 730px) 100vw, 730px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/ddf83ae71f9e532c86f178fb160cbd29/1a144/placeholder.jpg",
                "alt": "Placeholder image",
                "title": "Placeholder image",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span></p>
        <div className="homeButtons">SLAC Website</div>
      </a>
    </section>
    {
      /* PAST PUBLICATIONS --------------------------------------------------*/
    }
    <blockquote>
      <p parentName="blockquote">{`Past Publications`}</p>
    </blockquote>
    <section className="home-list">
      <Link to="/passing-2022" alt="Link to SLAC Passing Strange publication." mdxType="Link">
        <p><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "730px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "155.83333333333334%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGgAAAQUBAAAAAAAAAAAAAAAAAAEDBAUGAv/EABcBAQEBAQAAAAAAAAAAAAAAAAIDAAH/2gAMAwEAAhADEAAAAUbsG6xCWB1cTRcF0JpTm//EAB0QAAEEAwEBAAAAAAAAAAAAAAIAAQMREiEiEzH/2gAIAQEAAQUC7sXNRXiY6AWJAOhl7yofWQE+Sp03z//EABgRAAMBAQAAAAAAAAAAAAAAAAABAhFB/9oACAEDAQE/AVPRYTKRh//EABkRAAIDAQAAAAAAAAAAAAAAAAABAhESIf/aAAgBAgEBPwHY2OXSz//EAB4QAAIBBAMBAAAAAAAAAAAAAAABAhARITEiMpFR/9oACAEBAAY/Auz9Hzl6bY/g86dGpaLxZZSaphGT/8QAHhABAAICAwADAAAAAAAAAAAAAQARITFBcYFR0fH/2gAIAQEAAT8hqzGXCqoU0QLrbPLDLmhuUFWiuoGvzMvXkA8zASTUZvDMzh8/YFsL6+4VwB5P/9oADAMBAAIAAwAAABA090z/xAAYEQEBAQEBAAAAAAAAAAAAAAABABEhMf/aAAgBAwEBPxAgUyxyERfbJf/EABcRAQEBAQAAAAAAAAAAAAAAAAEAESH/2gAIAQIBAT8QQoZdJHQWr//EAB8QAQEAAwEAAQUAAAAAAAAAAAERACExQVFhkaHB0f/aAAgBAQABPxC3WF2xUAjV/c2GPaPhiCKF+BvfMYaj0SLHJ3uFXY1kGNrBFXv1ms20x5XSm5+PtiQ88A9blJRKEAOFV9dAYsELxH6XP//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7ca0d2363df9b50c20e6c4f871563c45/8ac56/passing-strange-cover.webp 240w", "/static/7ca0d2363df9b50c20e6c4f871563c45/d3be9/passing-strange-cover.webp 480w", "/static/7ca0d2363df9b50c20e6c4f871563c45/87ca7/passing-strange-cover.webp 730w"],
                "sizes": "(max-width: 730px) 100vw, 730px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7ca0d2363df9b50c20e6c4f871563c45/09b79/passing-strange-cover.jpg 240w", "/static/7ca0d2363df9b50c20e6c4f871563c45/7cc5e/passing-strange-cover.jpg 480w", "/static/7ca0d2363df9b50c20e6c4f871563c45/1a144/passing-strange-cover.jpg 730w"],
                "sizes": "(max-width: 730px) 100vw, 730px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/7ca0d2363df9b50c20e6c4f871563c45/1a144/passing-strange-cover.jpg",
                "alt": "Passing Strange Cover",
                "title": "Passing Strange Cover",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span></p>
  <div className="homeButtons">Passing Strange</div>
      </Link>
      <Link to="/egress-2022" alt="Link to SLAC Egress publication." mdxType="Link">
        <p><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "730px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "155.83333333333334%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGQABAQEAAwAAAAAAAAAAAAAABAACAQMF/8QAFwEAAwEAAAAAAAAAAAAAAAAAAAEDAv/aAAwDAQACEAMQAAAB9TQlal2RJoHOVsHGrz//xAAaEAEAAwEBAQAAAAAAAAAAAAABAAIDEhEE/9oACAEBAAEFArXlVTqL7MvCvcLRsTuY5mi/PQJ//8QAGREAAwADAAAAAAAAAAAAAAAAAAECEBES/9oACAEDAQE/AZrbOxQ2sf/EABkRAAMBAQEAAAAAAAAAAAAAAAABAhEDEv/aAAgBAgEBPwFrEeSukTWMw//EABoQAQACAwEAAAAAAAAAAAAAAAEAEBEgITH/2gAIAQEABj8CjfurlY9a/8QAHBABAAICAwEAAAAAAAAAAAAAAQAREEEhMVGx/9oACAEBAAE/IUKCOC3WWXNFvspPVml9wKAUajl1l4//2gAMAwEAAgADAAAAEDzMzf/EABgRAAMBAQAAAAAAAAAAAAAAAAABERAh/9oACAEDAQE/EGSLLRLmf//EABcRAAMBAAAAAAAAAAAAAAAAAAABERD/2gAIAQIBAT8QzNgOkH//xAAcEAEBAAIDAQEAAAAAAAAAAAABEQAhMUFxUZH/2gAIAQEAAT8QVQC98zCYJ9eZ6wIRL8e8oyqrQUNY0Y6uBRKfLvEWuNF0xQy3zCdJJZtuCR1AU3rzLQa/uf/Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ebd73ea67461514f2cbe588b3cb5ea4d/8ac56/egress-cover.webp 240w", "/static/ebd73ea67461514f2cbe588b3cb5ea4d/d3be9/egress-cover.webp 480w", "/static/ebd73ea67461514f2cbe588b3cb5ea4d/87ca7/egress-cover.webp 730w"],
                "sizes": "(max-width: 730px) 100vw, 730px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ebd73ea67461514f2cbe588b3cb5ea4d/09b79/egress-cover.jpg 240w", "/static/ebd73ea67461514f2cbe588b3cb5ea4d/7cc5e/egress-cover.jpg 480w", "/static/ebd73ea67461514f2cbe588b3cb5ea4d/1a144/egress-cover.jpg 730w"],
                "sizes": "(max-width: 730px) 100vw, 730px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/ebd73ea67461514f2cbe588b3cb5ea4d/1a144/egress-cover.jpg",
                "alt": "Egress Cover",
                "title": "Egress Cover",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span></p>
  <div className="homeButtons">Egress</div>
      </Link>
      <Link to="/piggie-2021" alt="Link to SLAC Elephant and Piggie publication." mdxType="Link">
        <p><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "387px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "155.83333333333334%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,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')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e12f78baf46165207f3d90e0e26db14a/8ac56/piggie-cover.webp 240w", "/static/e12f78baf46165207f3d90e0e26db14a/bbd0d/piggie-cover.webp 387w"],
                "sizes": "(max-width: 387px) 100vw, 387px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e12f78baf46165207f3d90e0e26db14a/8ff5a/piggie-cover.png 240w", "/static/e12f78baf46165207f3d90e0e26db14a/691c3/piggie-cover.png 387w"],
                "sizes": "(max-width: 387px) 100vw, 387px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/e12f78baf46165207f3d90e0e26db14a/691c3/piggie-cover.png",
                "alt": "Elephant & Piggie Cover",
                "title": "Elephant & Piggie Cover",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span></p>
  <div className="homeButtons">Elephant & Piggie</div>
      </Link>
      <Link to="/four-women2021" alt="Link to SLAC Four Women… publication." mdxType="Link">
        <p><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "730px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "155.83333333333334%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAMCBAUB/8QAFwEBAQEBAAAAAAAAAAAAAAAAAAMBAv/aAAwDAQACEAMQAAAB0lKFdIxTlc7COq4wq//EAB0QAAICAgMBAAAAAAAAAAAAAAECAxEAEgQQEzP/2gAIAQEAAQUCZ9lWTTN1y7aSMsqhQsAsseuN9Wje/Jzn/8QAHBEAAQMFAAAAAAAAAAAAAAAAAAECIRESMVFh/9oACAEDAQE/AWrBa3ZiCnT/xAAaEQACAwEBAAAAAAAAAAAAAAAAAQIRISJR/9oACAECAQE/AZclPwauWmH/xAAhEAACAQIGAwAAAAAAAAAAAAAAASEQERIxMkFRYXGRof/aAAgBAQAGPwKCXBqXumFZiVh3G1tRrofHkhfT/8QAHhAAAgICAgMAAAAAAAAAAAAAAAERITFRQZFxocH/2gAIAQEAAT8hVNJJ7JCJHnrCkQ6PYxgu5haFRyrBoNsE+Oimn9DMPKA4zpZ//9oADAMBAAIAAwAAABDfK3D/xAAZEQEBAQADAAAAAAAAAAAAAAABACERYZH/2gAIAQMBAT8QBZHBsdIu49v/xAAYEQEBAQEBAAAAAAAAAAAAAAABABEhUf/aAAgBAgEBPxDID2bZCuELv//EAB8QAQEAAgEEAwAAAAAAAAAAAAERACFRMUFxsWHR8f/aAAgBAQABPxATxgIpzlY4mNqHzjNDS7+zHCa2+McIGyi2DcZ4xdhSsYlP6o8y4F0Id07Q95f4YgnQvphwXeLp14wQYKlx/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c667d2fdf5948a2b616431dc48afb4d2/8ac56/fourWomen-cover.webp 240w", "/static/c667d2fdf5948a2b616431dc48afb4d2/d3be9/fourWomen-cover.webp 480w", "/static/c667d2fdf5948a2b616431dc48afb4d2/87ca7/fourWomen-cover.webp 730w"],
                "sizes": "(max-width: 730px) 100vw, 730px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c667d2fdf5948a2b616431dc48afb4d2/09b79/fourWomen-cover.jpg 240w", "/static/c667d2fdf5948a2b616431dc48afb4d2/7cc5e/fourWomen-cover.jpg 480w", "/static/c667d2fdf5948a2b616431dc48afb4d2/1a144/fourWomen-cover.jpg 730w"],
                "sizes": "(max-width: 730px) 100vw, 730px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c667d2fdf5948a2b616431dc48afb4d2/1a144/fourWomen-cover.jpg",
                "alt": "Four Women Cover",
                "title": "Four Women Cover",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span></p>
  <div className="homeButtons">Four Women…</div>
      </Link>
      <Link to="/slacabaret" alt="Link to SLAC Cabaret publication." mdxType="Link">
        <p><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "730px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "155.83333333333334%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAMBAgT/xAAWAQEBAQAAAAAAAAAAAAAAAAADBAL/2gAMAwEAAhADEAAAAYJyacLjE9GtU9Kyo4f/xAAdEAACAgIDAQAAAAAAAAAAAAAAAQIRAyESIjJB/9oACAEBAAEFAko1WMa3xM0aj8ZNdB1WiPn/xAAVEQEBAAAAAAAAAAAAAAAAAAACEP/aAAgBAwEBPwFRT//EABcRAAMBAAAAAAAAAAAAAAAAAAECEAP/2gAIAQIBAT8BUzOf/8QAGhAAAgMBAQAAAAAAAAAAAAAAAAEQITEREv/aAAgBAQAGPwK2ayjUd9KXGwj/xAAbEAADAQADAQAAAAAAAAAAAAAAARFBMVFhkf/aAAgBAQABPyGFRPR7fIXWBoTouTGJRE3fRSyfDlUXReoR1GxuPo//2gAMAwEAAgADAAAAEAs7jP/EABcRAQEBAQAAAAAAAAAAAAAAAAEAESH/2gAIAQMBAT8Q4LIiWX//xAAXEQEBAQEAAAAAAAAAAAAAAAABABEh/9oACAECAQE/EOGwz0h5f//EAB8QAQACAgICAwAAAAAAAAAAAAEAESExQVFhkdHh8P/aAAgBAQABPxBOSuhx4iTZ5r6TZnS44EyA5ckM1ABtsvTHsCAPbzKITANJL7MwQBpLlmv4m4sbBW34gOxiesT/2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/cb64d2279b1bbd3bdbb3ba2ec5bab3d6/8ac56/cabaret-cover.webp 240w", "/static/cb64d2279b1bbd3bdbb3ba2ec5bab3d6/d3be9/cabaret-cover.webp 480w", "/static/cb64d2279b1bbd3bdbb3ba2ec5bab3d6/87ca7/cabaret-cover.webp 730w"],
                "sizes": "(max-width: 730px) 100vw, 730px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/cb64d2279b1bbd3bdbb3ba2ec5bab3d6/09b79/cabaret-cover.jpg 240w", "/static/cb64d2279b1bbd3bdbb3ba2ec5bab3d6/7cc5e/cabaret-cover.jpg 480w", "/static/cb64d2279b1bbd3bdbb3ba2ec5bab3d6/1a144/cabaret-cover.jpg 730w"],
                "sizes": "(max-width: 730px) 100vw, 730px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/cb64d2279b1bbd3bdbb3ba2ec5bab3d6/1a144/cabaret-cover.jpg",
                "alt": "SLACABARET Cover",
                "title": "SLACABARET Cover",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span></p>
  <div className="homeButtons">#SLACABARET</div>
      </Link>
    </section>
    <br />
    <br />
    <hr />
    <br />
    <p>
  Salt Lake Acting Company’s mission is to engage and enrich community through
  brave, contemporary theatre. By producing boundary-pushing new plays, SLAC
  carves space for adventurous community members to gather and participate in
  theatre that would not otherwise happen in Utah. Counter to the dominant
  statewide culture, our reclaimed church building is a resource and refuge for
  marginalized and liberated individuals to connect, celebrate, and challenge
  the status quo. Nestled in the eccentric Marmalade District, our unique
  onion-domed wardhouse serves as a memorable home for singular theatre
  experiences savored by audiences throughout the Wasatch Front.
    </p>
    <Randomizer mdxType="Randomizer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      